<template>
  <div class="aside-internal-note space-x-3">
    <div style="width: 20px">
      <AgentAvatar v-bind:agent="agent" diameter="25" />
    </div>
    <div class="flex-1 space-y-1">
      <div class="flex items-center justify-between">
        <h3 class="text-sm font-medium">{{agent.attributes.name}}</h3>
      </div>
      <p class="text-sm text-gray-500 break-words whitespace-pre-line">{{message.text}}</p>
      <p class="text-sm text-gray-500">
        <Datetime v-bind:date="message.created_at" fromNow="true" />
      </p>
    </div>
  </div>
</template>


<script>
import AgentAvatar from '../../agents/AgentAvatar.vue'
import Datetime from '../../building_blocks/DateTime.vue'
import {useAgentStore} from "@/stores/agents";

export default {
  name: 'AsideInternalNoteItem',
  props: ['message'],
  components: {
    AgentAvatar,
    Datetime,
  },
  setup() {
    let agentStore = useAgentStore();
    return { agentStore };
  },
  computed: {
    agent() {
      return this.agentStore.getById(this.message.agent_id);
    }
  }
}
</script>
